import { CONFIG } from "./config.es6";

const DEBUG_PAIR_ROW_SIZE = 5;
// 絵柄だけでツガイを判別しづらいため、両方のカードへ同じ名称と支給デザイン色を重ねる。
const CARD_PAIRS = [
    { name: "左右様", color: "#fb646a" },
    { name: "ガブリエル", color: "#6581bd" },
    { name: "宇宙人的<br>なツガイ", color: "#b56786" },
    { name: "前虎後狼", color: "#7870e0" },
    { name: "狐狸変化", color: "#bf9f02" },
    { name: "兎と亀", color: "#69cafd" },
    { name: "ザシキ<br>ワラシ", color: "#4fc767" },
    { name: "黒白", color: "#787896" },
    { name: "えっさ・<br>ほいさ", color: "#f0924e" },
    { name: "掃除屋", color: "#71894d" },
    { name: "百鬼夜行", color: "#a18136" },
    { name: "マガツヒ", color: "#927e73" },
    { name: "閻魔帳", color: "#b26e5b" },
    { name: "手長足長", color: "#3bbdb3" },
    { name: "レディー・<br>ジェントルマン", color: "#ff80d9" },
    { name: "金烏玉兎", color: "#965c99" },
    { name: "風神雷神", color: "#478b8f" },
    { name: "マメガラス", color: "#76a653" },
    { name: "陰陽", color: "#17c7fc" },
    { name: "なもみはぎ", color: "#399e74" },
];

export default class Cards {
    constructor(board) {
        this.board = board;
    }

    createDeck({ adjacentPairs = false } = {}) {
        const cards = [];
        for (let pair = 1; pair <= CONFIG.totalPairs; pair += 1) {
            cards.push(this.createCardData(pair, 1));
            cards.push(this.createCardData(pair, 2));
        }
        return adjacentPairs ? this.createAdjacentPairDeck() : this.shuffle(cards);
    }

    createAdjacentPairDeck() {
        const cards = [];

        // 5列盤面で同じ組の片割れが上下に並ぶよう、5組ずつ2行に分ける。
        for (let pairStart = 1; pairStart <= CONFIG.totalPairs; pairStart += DEBUG_PAIR_ROW_SIZE) {
            const pairEnd = Math.min(pairStart + DEBUG_PAIR_ROW_SIZE - 1, CONFIG.totalPairs);

            for (let side = 1; side <= 2; side += 1) {
                for (let pair = pairStart; pair <= pairEnd; pair += 1) {
                    cards.push(this.createCardData(pair, side));
                }
            }
        }

        return cards;
    }

    createCardData(pair, side) {
        const pairData = CARD_PAIRS[pair - 1];
        return {
            id: `${pair}-${side}`,
            pair: String(pair),
            side: String(side),
            image: `${CONFIG.imageDirectory}ph_${pair}_${side}.webp`,
            name: pairData.name,
            color: pairData.color,
        };
    }

    shuffle(cards) {
        const shuffled = [...cards];
        for (let i = shuffled.length - 1; i > 0; i -= 1) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    }

    renderCards(deck) {
        const fragment = document.createDocumentFragment();
        this.board.innerHTML = "";

        deck.forEach((card, index) => {
            const backImage = index % 2 === 0 ? "ph_bg_2.webp" : "ph_bg_1.webp";
            const button = document.createElement("button");
            button.type = "button";
            button.className = "shinkeisuijaku-card js-shinkeisuijaku-card";
            button.dataset.cardIndex = String(index);
            button.dataset.pair = card.pair;
            button.dataset.side = card.side;
            button.dataset.cardName = card.name;
            button.style.setProperty("--shinkeisuijaku-card-label-color", card.color);
            button.setAttribute("aria-label", `カード ${index + 1}、伏せた状態`);
            button.setAttribute("aria-pressed", "false");
            const nameSizeClass = card.name.length >= 15 ? " -xlong" : card.name.length >= 7 ? " -long" : "";
            button.innerHTML = `
                <span class="shinkeisuijaku-card__inner">
                    <span class="shinkeisuijaku-card__face -back" aria-hidden="true">
                        <img src="${CONFIG.imageDirectory}${backImage}" alt="">
                    </span>
                    <span class="shinkeisuijaku-card__face -front" aria-hidden="true">
                        <img src="${card.image}" alt="">
                        <span class="shinkeisuijaku-card__name" aria-hidden="true">
                            <span class="shinkeisuijaku-card__name-board c-font-noto-sans${nameSizeClass} js-shinkeisuijaku-card-name"></span>
                        </span>
                    </span>
                </span>
            `;
            button.querySelector(".js-shinkeisuijaku-card-name").innerHTML = card.name;
            fragment.appendChild(button);
        });

        this.board.appendChild(fragment);
    }

    openCard(element) {
        element.classList.add("is-flipped");
        element.setAttribute("aria-pressed", "true");
        element.setAttribute("aria-label", `${element.getAttribute("aria-label").split("、")[0]}、${element.dataset.cardName}、表向き`);
    }

    closeCard(element) {
        element.classList.remove("is-flipped");
        element.setAttribute("aria-pressed", "false");
        element.setAttribute("aria-label", `${element.getAttribute("aria-label").split("、")[0]}、伏せた状態`);
    }

    matchCard(element) {
        element.classList.add("is-matched");
        element.disabled = true;
        element.setAttribute("aria-label", `${element.getAttribute("aria-label").split("、")[0]}、${element.dataset.cardName}、成立済み`);

        // 成立後はカードの絵柄だけを残す仕様のため、再表示されないようDOMから取り除く。
        const name = element.querySelector(".js-shinkeisuijaku-card-name");
        if (name) name.closest(".shinkeisuijaku-card__name").remove();
    }
}
